"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebViewController = void 0;
var tslib_1 = require("tslib");
var hybridBridge_1 = (0, tslib_1.__importDefault)(require("../hybridBridge"));
var registerGlobalValue_1 = require("../utils/registerGlobalValue");
/**
 * Android WebView 控件。
 */
var WebViewController = /** @class */ (function () {
    function WebViewController() {
        var _this = this;
        this.initializing = false;
        Promise.resolve().then(function () { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var error_1;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.checkBridgeReady()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.warn(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    }
    WebViewController.prototype.checkBridgeReady = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = 6000; }
        if (this.hybridBridge)
            return true;
        return new Promise(function (resolve, reject) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var check_1, hybridBridge_2, _a, res, error;
            var _this = this;
            return (0, tslib_1.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.hybridBridge)
                            return [2 /*return*/, resolve(true)];
                        if (!this.initializing) return [3 /*break*/, 1];
                        check_1 = function () {
                            if (_this.hybridBridge)
                                return resolve(true);
                            requestAnimationFrame(check_1);
                        };
                        check_1();
                        return [3 /*break*/, 3];
                    case 1:
                        this.initializing = true;
                        hybridBridge_2 = new hybridBridge_1.default();
                        return [4 /*yield*/, hybridBridge_2.initialize(timeout)];
                    case 2:
                        _a = _b.sent(), res = _a[0], error = _a[1];
                        if (!res || error) {
                            return [2 /*return*/, reject(error || new Error('HybridBridge 初始化失败~'))];
                        }
                        hybridBridge_2 === null || hybridBridge_2 === void 0 ? void 0 : hybridBridge_2.getStaticData((0, registerGlobalValue_1.registerGlobalValue)('HYBRID_BRIDGE_NAME', function (data) {
                            _this.deviceInfo = (function () {
                                try {
                                    return JSON.parse(data);
                                }
                                catch (e) {
                                    return data;
                                }
                            })();
                            _this.hybridBridge = hybridBridge_2;
                            _this.initializing = false;
                            return resolve(true);
                        }));
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    WebViewController.prototype.checkReady = function (timeout) {
        if (timeout === void 0) { timeout = 6000; }
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var res, _a, _b, error_2;
            return (0, tslib_1.__generator)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        res = [null, null];
                        if (this.hybridBridge) {
                            res[0] = true;
                            return [2 /*return*/, res];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        _a = res;
                        _b = 0;
                        return [4 /*yield*/, this.checkBridgeReady(timeout)];
                    case 2:
                        _a[_b] = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _c.sent();
                        res[0] = false;
                        res[1] = error_2;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, res];
                }
            });
        });
    };
    Object.defineProperty(WebViewController.prototype, "ready", {
        get: function () {
            return !!this.hybridBridge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebViewController.prototype, "scheme", {
        get: function () {
            var _a;
            return ((_a = this.deviceInfo) === null || _a === void 0 ? void 0 : _a.scheme) || '';
        },
        enumerable: false,
        configurable: true
    });
    WebViewController.prototype.createSchemeLink = function (schemeUrl) {
        if (schemeUrl.startsWith(this.scheme)) {
            return schemeUrl;
        }
        return this.scheme + '://' + schemeUrl;
    };
    WebViewController.prototype.callAndBackfeed = function (scheme) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var res, _a, ready, readyError;
            var _this = this;
            return (0, tslib_1.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        res = [false, null];
                        return [4 /*yield*/, this.checkReady()];
                    case 1:
                        _a = _b.sent(), ready = _a[0], readyError = _a[1];
                        if (!ready) {
                            res[0] = false;
                            res[1] = readyError;
                            return [2 /*return*/, res];
                        }
                        return [4 /*yield*/, new Promise(function (resolve) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                                var actionUrl, msg;
                                return (0, tslib_1.__generator)(this, function (_a) {
                                    actionUrl = this.createSchemeLink(scheme);
                                    msg = JSON.stringify({
                                        actionUrl: actionUrl,
                                        functionName: (0, registerGlobalValue_1.registerGlobalValue)(this.createSchemeLink(scheme), function (data) {
                                            var d = data;
                                            try {
                                                d = JSON.parse(data);
                                            }
                                            catch (e) {
                                                /** no-care */
                                            }
                                            res[0] = (function () {
                                                if (d === 1)
                                                    return true;
                                                if (d === 0)
                                                    return false;
                                                return d;
                                            })();
                                            resolve(res);
                                        }),
                                    });
                                    this.hybridBridge.callAndBackfeed(msg);
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 2: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    WebViewController.prototype.callAndListen = function (scheme, callback) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var res, _a, ready, readyError;
            var _this = this;
            return (0, tslib_1.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        res = [false, null];
                        return [4 /*yield*/, this.checkReady()];
                    case 1:
                        _a = _b.sent(), ready = _a[0], readyError = _a[1];
                        if (!ready) {
                            res[0] = false;
                            res[1] = readyError;
                            return [2 /*return*/, res];
                        }
                        return [4 /*yield*/, new Promise(function (resolve) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                                var actionUrl, _callback, msg;
                                return (0, tslib_1.__generator)(this, function (_a) {
                                    actionUrl = this.createSchemeLink(scheme);
                                    _callback = function (data) {
                                        var d = data;
                                        try {
                                            d = JSON.parse(data);
                                        }
                                        catch (e) {
                                            /** no-care */
                                        }
                                        var callbackParam = (function () {
                                            if (d === 1)
                                                return true;
                                            if (d === 0)
                                                return false;
                                            return d;
                                        })();
                                        callback(callbackParam);
                                        res[0] = function () {
                                            // 清理掉当前的回调引用
                                            var callbacks = registerGlobalValue_1.cache[actionUrl];
                                            if (!callbacks)
                                                return;
                                            var idx = callbacks.queue.findIndex(function (func) { return func.callback === _callback; });
                                            if (idx !== -1) {
                                                callbacks.queue.splice(idx, 1);
                                            }
                                        };
                                        resolve(res);
                                    };
                                    msg = JSON.stringify({
                                        actionUrl: actionUrl,
                                        functionName: (0, registerGlobalValue_1.registerGlobalValue)(actionUrl, _callback, false),
                                    });
                                    this.hybridBridge.callAndListen(msg);
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 2: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    return WebViewController;
}());
exports.WebViewController = WebViewController;
//# sourceMappingURL=WebViewController.js.map